
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/allowances",
      function () {
        return require("private-next-pages/allowances.tsx");
      }
    ]);
  